module.exports = __webpack_public_path__ + "static/media/bathroom-re-fit_02.cdb7fc6a.png";